import { createSelector } from 'selectors'
import { crossTable } from './constant'

const { crossTableSettings, crossTableQuestionsOverview } = crossTable

const getCrossTableEditorQuestionsSelector = (): HTMLElement =>
	createSelector({ selector: crossTableSettings.editorQuestions })
const getCrossTableEditorAvailableQuestionsSelector = (scope?: HTMLElement): HTMLElement =>
	createSelector({ scope, selector: crossTableSettings.editorAvailableQuestions })
const getCrossTableEditorAssignedQuestionsSelector = (scope?: HTMLElement): HTMLElement =>
	createSelector({ scope, selector: crossTableSettings.editorAssignedQuestions })

export const getCrossTableEditorSelectors = () => {
	const crossTableEditorQuestions = getCrossTableEditorQuestionsSelector()
	if (!crossTableEditorQuestions) {
		return null
	}

	return {
		editorQuestions: crossTableEditorQuestions,
		editorAvailableQuestions: getCrossTableEditorAvailableQuestionsSelector(crossTableEditorQuestions),
		editorAssignedQuestions: getCrossTableEditorAssignedQuestionsSelector(crossTableEditorQuestions),
	}
}

const getCrossTableQuestionsOverviewSelector = (): HTMLElement =>
	createSelector({ selector: crossTableQuestionsOverview.questionsOverview })

const getCrossTableQuestionsOverviewCollapsibleSelector = (scope: HTMLElement): HTMLElement =>
	createSelector({ scope, selector: crossTableQuestionsOverview.questionsOverviewCollapsible })

export const getCrossTableMetadataEditIconsSelector = (scope: HTMLElement): NodeListOf<HTMLInputElement> =>
	createSelector({ scope, selector: crossTableQuestionsOverview.metadataEdit }, true)

export const getCrossTableMetadataCheckboxesSelector = (scope: HTMLElement): NodeListOf<HTMLInputElement> =>
	createSelector({ scope, selector: crossTableQuestionsOverview.metadataCheckbox }, true)

export const getCrossTableQuestionsOverviewSelectors = () => {
	const scope = getCrossTableQuestionsOverviewSelector()
	if (!scope) {
		return null
	}

	return {
		questionsOverviewCollapsible: getCrossTableQuestionsOverviewCollapsibleSelector(scope),
		metadataEditIcons: getCrossTableMetadataEditIconsSelector(scope),
		metadataCheckboxes: getCrossTableMetadataCheckboxesSelector(scope),
	}
}

export const getCrossTableValueElementOfMetadataItem = (metadataItem: HTMLElement): HTMLElement =>
	createSelector({ scope: metadataItem, selector: crossTableQuestionsOverview.metadataValue })

export const getCrossTableTopBoxAnswersOfMetadataItem = (metadataItem: HTMLElement): HTMLElement =>
	createSelector({ scope: metadataItem, selector: crossTableQuestionsOverview.metadataTopBoxAnswers })

export const getCrossTableBottomBoxAnswersOfMetadataItem = (metadataItem: HTMLElement): HTMLElement =>
	createSelector({ scope: metadataItem, selector: crossTableQuestionsOverview.metadataBottomBoxAnswers })

export const getCrossTableDetractorsOfMetadataItem = (metadataItem: HTMLElement): HTMLElement =>
	createSelector({ scope: metadataItem, selector: crossTableQuestionsOverview.metadataDetractors })

export const getCrossTablePromotersOfMetadataItem = (metadataItem: HTMLElement): HTMLElement =>
	createSelector({ scope: metadataItem, selector: crossTableQuestionsOverview.metadataPromoters })

export const getCrossTableEditInfoElement = (collapsibleItem: HTMLElement): HTMLElement =>
	createSelector({ scope: collapsibleItem, selector: crossTableQuestionsOverview.editInfoElement })
